import { Container, Row, Col } from "react-bootstrap";
import { Helmet } from "react-helmet";
import Layout from "../Utils/Layout";
import { useNavigate } from "react-router-dom";

const WebDevelopment = () => {
  const navigate = useNavigate();
  return (
    <Layout>
      <div className="py-4 fs-3 ps-3" data-aos="fade-left">
        <button
          onClick={() => navigate(-1)}
          className="btn btn-info fw-bold ms-5"
        >
          Back
        </button>
      </div>
      <div></div>
      <div>
        <Helmet>
          <title>Web Development Services | Shoyeb</title>
          <meta
            name="description"
            content="Create reliable, secure, and responsive websites with our professional web development services. Utilizing the latest technologies, we deliver custom solutions tailored to your business needs."
          />
          <meta
            name="keywords"
            content="web development services, website development, frontend development, backend development"
          />
        </Helmet>
        <Container>
          <Row className="mt-5">
            <Col data-aos="fade-right">
              <h1 className="text-center">Web Development Services</h1>
              <p className="lead text-center">
                Build a strong online presence with our expert web development
                solutions tailored to your business requirements.
              </p>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col md={6} data-aos="fade-up">
              <h3>Our Services</h3>
              <ul>
                <li>Frontend development</li>
                <li>Backend development</li>
                <li>Full stack development</li>
                <li>Custom web application development</li>
                <li>Responsive web design</li>
              </ul>
            </Col>
            <Col md={6} data-aos="fade-down">
              <h3>Why Choose Us?</h3>
              <p>
                Our experienced team of web developers specializes in creating
                reliable, secure, and responsive websites using cutting-edge
                technologies. We prioritize user experience and functionality to
                deliver custom solutions that meet your business objectives.
              </p>
              <p>
                Whether you need a simple landing page or a complex web
                application, we have the expertise to bring your ideas to life
                and exceed your expectations.
              </p>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col data-aos="fade-left">
              <h3>Recent Projects</h3>
              <p>
                Here are some examples of the web development projects
                we&apos;ve worked on:
              </p>
              <ul>
                <li>E-commerce websites</li>
                <li>Content management systems (CMS)</li>
                <li>Custom web applications</li>
                <li>Corporate websites</li>
                <li>Portfolio websites</li>
              </ul>
            </Col>
          </Row>
          <Row className="mt-5">
            <Col data-aos="fade-right">
              <h3>Contact Us</h3>
              <p>Ready to take your online presence to the next level?</p>
              <a href="mailto:shoyebmd424@mail.com" className="btn btn-info">
                Contact Us
              </a>{" "}
            </Col>
          </Row>
        </Container>
      </div>
    </Layout>
  );
};

export default WebDevelopment;
